// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-30kzo";
var _4 = "overlay-3b9LE";
var _5 = "content-2uLdI";
var _6 = "levelImage-kzIfK";
var _7 = "authorized-1GXBF";
var _8 = "silver-1Cgif";
var _9 = "gold-23iPB";
var _a = "platinum-K-BJU";
var _b = "standart-3eQcW";
var _c = "diamond-1phmd";
var _d = "vip-3-54-";
var _e = "red-3oSyl";
var _f = "temporary-LpYxv";
var _10 = "nickel-WwZBp";
var _11 = "base-1OXvR";
var _12 = "bronze-DsvtB";
var _13 = "basic-1b6CX";
var _14 = "compliment-28xne";
var _15 = "appreciation-hOoLV";
var _16 = "gratitude-FBR-H";
var _17 = "corporate-11dr_";
var _18 = "header-3wSuI";
var _19 = "level-2OjDa";
var _1a = "info-1FSDc";
var _1b = "number-39cKI";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "overlay", _5 as "content", _6 as "levelImage", _7 as "authorized", _8 as "silver", _9 as "gold", _a as "platinum", _b as "standart", _c as "diamond", _d as "vip", _e as "red", _f as "temporary", _10 as "nickel", _11 as "base", _12 as "bronze", _13 as "basic", _14 as "compliment", _15 as "appreciation", _16 as "gratitude", _17 as "corporate", _18 as "header", _19 as "level", _1a as "info", _1b as "number" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "overlay": _4, "content": _5, "levelImage": _6, "authorized": _7, "silver": _8, "gold": _9, "platinum": _a, "standart": _b, "diamond": _c, "vip": _d, "red": _e, "temporary": _f, "nickel": _10, "base": _11, "bronze": _12, "basic": _13, "compliment": _14, "appreciation": _15, "gratitude": _16, "corporate": _17, "header": _18, "level": _19, "info": _1a, "number": _1b }
